function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useEffect, useRef, useState } from 'react';
import classnames from 'classnames/bind';
import Utility from "../../Utility/Utility";
import { ThemeContext } from "../../../context/theme.context";
import styles from "./TextInput.module.scss";

// Classnames bind variant.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var cx = classnames.bind(styles);
export var TextInput = function TextInput(_ref) {
  var _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    _ref$id = _ref.id,
    initId = _ref$id === void 0 ? '' : _ref$id,
    _ref$inputAttributes = _ref.inputAttributes,
    inputAttributes = _ref$inputAttributes === void 0 ? {} : _ref$inputAttributes,
    _ref$inputClassName = _ref.inputClassName,
    inputClassName = _ref$inputClassName === void 0 ? '' : _ref$inputClassName,
    _ref$onChangeText = _ref.onChangeText,
    onChangeText = _ref$onChangeText === void 0 ? function () {} : _ref$onChangeText,
    _ref$onKeyDown = _ref.onKeyDown,
    onKeyDown = _ref$onKeyDown === void 0 ? function () {} : _ref$onKeyDown,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$text = _ref.text,
    initText = _ref$text === void 0 ? '' : _ref$text,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  var theme = useContext(ThemeContext);
  var textInputInputClasses = cx({
    textInputInput: true
  });
  var id = useRef(initId || Utility.generateUID('text-input')).current;
  var _useState = useState(initText),
    _useState2 = _slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    inputFocus = _useState4[0],
    setInputFocus = _useState4[1];
  var addVariant = variant !== 'default';
  var variantClass = variant && variant.charAt(0).toUpperCase() + variant.slice(1);
  var onClick = function onClick() {
    if (!hasError) {
      onSubmit(text);
    }
  };
  var handleChangeText = function handleChangeText(e) {
    var text = e.target.value;
    setText(text);
    onChangeText(text);
  };
  var onBlurInput = function onBlurInput() {
    setInputFocus(false);
    onBlur();
  };
  var onFocusInput = function onFocusInput() {
    setInputFocus(true);
    onFocus();
  };
  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter') {
      onClick();
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    onKeyDown(e);
  };
  useEffect(function () {
    setText(initText);
  }, [initText]);
  return /*#__PURE__*/_jsxs("div", {
    className: cx({
      textInput: true,
      textInputDarkBackground: theme === 'darkBackground',
      textInputFocus: inputFocus,
      ["textInputVariant".concat(variantClass)]: addVariant,
      textInputError: hasError,
      textInputSmall: small
    }),
    "data-e2e-name": "text_input",
    children: [placeholder && /*#__PURE__*/_jsx("label", {
      className: cx({
        textInputLabel: true,
        textInputLabelEmpty: !inputFocus && text === '',
        ["textInputLabelVariant".concat(variantClass)]: addVariant
      }),
      htmlFor: id,
      "data-e2e-name": "text_input_label",
      children: placeholder
    }), /*#__PURE__*/_jsx("input", _objectSpread({
      className: classnames(textInputInputClasses, inputClassName, {
        [styles["textInputInputVariant".concat(variantClass)]]: addVariant
      }),
      id: id,
      type: "text",
      autoFocus: autoFocus,
      onBlur: onBlurInput,
      onChange: handleChangeText,
      onFocus: onFocusInput,
      onKeyPress: handleKeyPress,
      onKeyDown: handleKeyDown,
      size: 8,
      value: text,
      "data-e2e-name": "text_input_input",
      "aria-invalid": hasError
    }, inputAttributes))]
  });
};